import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import React from "react";
import awsconfig from "./aws-exports";
import Copyright from "./components/Copyright";
import MenuBar from "./components/MenuBar";
import Benchmark from "./pages/Benchmark";
import Catalogue from "./pages/Catalogue";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import PublicAssessments from "./pages/PublicAssessments";
import ViewPublicParticipantData from "./pages/ViewPublicAssessmentData";
import Account from "./pages/management/Account";
import ManageAccounts from "./pages/management/ManageAccounts";
import ManageAssessments from "./pages/management/ManageAssessments";
import EditAssessment from "./pages/management/EditAssessment";
import EditPublicAssessment from "./pages/management/EditPublicAssessment";
import ManageCustomers from "./pages/management/ManageCustomers";
import ManagePublicAssessments from "./pages/management/ManagePublicAssessments";
import RequireAuth from "./components/RequireAuth";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import { Box, Container } from "@mui/material";
import { Font } from "@react-pdf/renderer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Login } from "./pages/Login";
import { CGI_WHITE, languages } from "./helpers/enums";
import PerformAssessment from "./pages/PerformAssessment";
import AssessmentsEvaluations from "./pages/AssessmentsEvaluations";
import ShowEvaluation from "./pages/ShowEvaluation";

Amplify.configure(awsconfig);

Font.register({
  family: "Montserrat",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew-Y3tcoqK5.ttf",
    },
    {
      src: "https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtZ6Ew-Y3tcoqK5.ttf",
      fontWeight: 500,
    },
    {
      src: "https://fonts.gstatic.com/s/montserrat/v26/JTUFjIg1_i6t8kCHKm459Wx7xQYXK0vOoz6jq6R9aX9-p7K5ILg.ttf",
      fontWeight: "normal",
      fontStyle: "italic",
    },
  ],
});

function App() {
  const profileImageId = "Profilbild";

  const [language, setLanguage] = React.useState(languages.EN);

  return (
    <Authenticator.Provider>
      <BrowserRouter>
        <Box
          sx={{
            minHeight: "90vh",
            display: "block",
            bgcolor: CGI_WHITE,
            pb: 10,
          }}
        >
          <MenuBar language={language} setLanguage={setLanguage} />
          <Container maxWidth={false} disableGutters>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/publicAssessments/:assessmentId"
                element={<PublicAssessments language={language} />}
              />
              <Route path="/login" element={<Login />} />
              <Route
                path="/manageAccounts"
                element={
                  <RequireAuth>
                    <ManageAccounts />
                  </RequireAuth>
                }
              />

              <Route
                path="/manageAssessments"
                element={
                  <RequireAuth>
                    <ManageAssessments />
                  </RequireAuth>
                }
              />
              <Route
                path="/manageAssessments/:selectedAssessmentId"
                element={
                  <RequireAuth>
                    <EditAssessment language={language} />
                  </RequireAuth>
                }
              />
              <Route
                path="/manageCustomers"
                element={
                  <RequireAuth>
                    <ManageCustomers language={language} />
                  </RequireAuth>
                }
              />
              <Route
                path="/catalogue"
                element={
                  <RequireAuth>
                    <Catalogue language={language} />
                  </RequireAuth>
                }
              />
              <Route
                path="/performAssessment/:assignedAssessment"
                element={
                  <RequireAuth>
                    <PerformAssessment />
                  </RequireAuth>
                }
              />
              <Route
                path="/assessmentsEvaluations"
                element={
                  <RequireAuth>
                    <AssessmentsEvaluations />
                  </RequireAuth>
                }
              />
              <Route
                path="/showEvaluation/:evaluationId"
                element={
                  <RequireAuth>
                    <ShowEvaluation />
                  </RequireAuth>
                }
              />
              <Route
                path="/benchmark"
                element={
                  <RequireAuth>
                    <Benchmark />
                  </RequireAuth>
                }
              />
              <Route
                path="/managePublicAssessments"
                element={
                  <RequireAuth>
                    <ManagePublicAssessments />
                  </RequireAuth>
                }
              />
              <Route
                path="/managePublicAssessments/:selectedAssessmentId"
                element={
                  <RequireAuth>
                    <EditPublicAssessment language={language} />
                  </RequireAuth>
                }
              />
              <Route
                path="/publicAssessmentData/:selectedAssessmentId"
                element={
                  <RequireAuth>
                    <ViewPublicParticipantData language={language} />
                  </RequireAuth>
                }
              />
              <Route
                path="/account"
                element={
                  <RequireAuth>
                    <Account
                      profileImageId={profileImageId}
                      language={language}
                    />
                  </RequireAuth>
                }
              />
              {/* <Route
                path="/test"
                element={
                  <RequireAuth>
                    <TestPage />
                  </RequireAuth>
                }
              /> */}
              <Route path="*" element={<NoPage language={language} />} />
            </Routes>
          </Container>
        </Box>
        <Copyright />
      </BrowserRouter>
    </Authenticator.Provider>
  );
}

export default App;
